export const BuiltinObjectGUID = {
    WhiteTexture: 'whitetexture00000000000000000000',
    TransparentTexture: 'transparenttexture00000000000000000000',
    PBRShader: 'pbr00000000000000000000000000000',
    UnlitShader: 'unlit000000000000000000000000000',
};
